import isbot from 'isbot';

export const useIsBot = (): boolean => {
  if (typeof window !== 'undefined') {
    return isbot(window.navigator.userAgent);
  }

  return false;
};
